module.exports = __webpack_public_path__ + "img/building.f71f15f7.svg";